import IconCaret from './IconCaret';

export const Accordion = ({ title, children, setOpenedAccordions, openedAccordions }) => {
  const open = openedAccordions.includes(title);

  const accordionToggle = () => {
    if (open) {
      setOpenedAccordions(openedAccordions.filter(accordion => accordion !== title));
    } else {
      setOpenedAccordions([...openedAccordions, title]);
    }
  }

  return (
    <div className="accordion">
      <input
        className={`accordion__checkbox ${open ? 'accordion__checkbox--open' : ''}`}
        type="checkbox"
        id={title}
        {...open && { checked: true }}
        onChange={accordionToggle}
      />
      <label className="accordion__title" htmlFor={title}>
        {title}

        <span className="accordion__icon">
          <IconCaret />
        </span>
      </label>

      <div className="accordion__content">
        <div className="accordion__content-inner">{children}</div>
      </div>
    </div>
  );
}
